import axiosGlobal from "@/main";
import {
  SlyShoppingNewWaveDataResponse as SlyShoppingNewWaveDataResponse,
  SlyShoppingNewPrize,
  SlyShoppingWaveModel,
} from "@/models/sly-shopping-admin-tab";
import { SlyShoppingPrizeDescription } from "@/models/sly-shopping-prize-description";
import { SlyShoppingStatusDescription } from "@/models/sly-shopping-status-description";
import { SlyShoppingWave } from "@/models/sly-shopping-wave";

export default {
  async getWaves(): Promise<SlyShoppingWave[]> {
    try {
      const response = await axiosGlobal.get<any[]>(`/api/prizemetro/waves`);
      const waves = response.data.map((wave: any) => {
        const newWave = new SlyShoppingWave();
        newWave.dateFrom = wave.date_from ? wave.date_from : wave.dateFrom;
        newWave.dateTo = wave.date_to ? wave.date_to : wave.dateTo;
        newWave.wave_id = wave.wave_id;
        return newWave;
      });
      return waves;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
  async getStatusDescriptions(): Promise<SlyShoppingStatusDescription[]> {
    try {
      const response = await axiosGlobal.get<SlyShoppingStatusDescription[]>(
        `/api/prizemetro/prize_status_descriptions`
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
  async getPrizeDescriptions(): Promise<SlyShoppingPrizeDescription[]> {
    try {
      const response = await axiosGlobal.get<SlyShoppingPrizeDescription[]>(
        `/api/prizemetro/prize_descriptions`
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
  async addPrizeData(newPrizes: SlyShoppingNewPrize[]): Promise<any> {
    try {
      const requestUri = `/api/prizemetro/add_prize_data`;
      const response = await axiosGlobal.post<any>(requestUri, newPrizes, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data?.results;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
  async getNewWaveData(): Promise<SlyShoppingNewWaveDataResponse | undefined> {
    try {
      const requestUri = `/api/prizemetro/get_new_wave_data`;
      const response = await axiosGlobal.get<SlyShoppingNewWaveDataResponse | undefined>(requestUri);
      if (response.status == 204) {
        return undefined;
      }
      return response.data;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
  async getWaveModels(): Promise<SlyShoppingWaveModel[]> {
    const waves = await this.getWaves();
    const prizes = await this.getPrizeDescriptions();
    return waves.map(
      (wave: SlyShoppingWave) =>
        new SlyShoppingWaveModel(
          wave,
          prizes.filter((prize: SlyShoppingPrizeDescription) => prize.wave_id == wave.wave_id)
        )
    );
  },
};
